export const ChevronUpDown = ({ className = "", strokeWidth, direction }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={strokeWidth ?? 1} stroke="currentColor" className={className}>
            <path d="M8 9L12 5L16 9" opacity={direction === "up" ? 1 : .5} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 15L12 19L8 15" opacity={direction === "down" ? 1 : .5} stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}